module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "28422819723-h99a73uit4ib63jov9vl0f4ne3rmjana.apps.googleusercontent.com",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },

  ActiveClient: "mypos", //If the active client is empty, "cargills" will be used as the default.else mysky

  cargills: {
    logo: "cargills_GO.png",
    logoLightPng: "cargills.png",
    logoLightSvg: "cargills_GO.png",
    logoDark: "cargills.png",
    theme: 'light',
    companyName: "myPOS",
    fullName: "myPOS  Software Solutions",
    webUrl: "https://www.mypos.lk",
    welcomeMessage: "Welcome to myPOS Cloud",
    loginUIMessage: "myPOS Cloud",
  },
  mysky: {
    logo: "mySky.png",
    logoLightPng: "mySky_GO.png",
    logoLightSvg: "mySky.png",
    logoDark: "mySky_GO.png",
    theme: 'light',
    companyName: "24x7 Retail",
    fullName: "24x7 Retail Software Solutions",
    webUrl: "https://www.24x7retail.online",
    welcomeMessage: "Welcome to 24x7 Retail Cloud",
    loginUIMessage: "24x7 Retail Cloud",
  },
  mypos: {
    logo: "myPOS.png",
    logoLightPng: "myPOS_GO.png",
    logoLightSvg: "myPOS_GO.png",
    logoDark: "myPOS_GO.png",
    theme: 'light',
    companyName: "myPOS",
    fullName: "myPOS  Software Solutions",
    webUrl: "https://www.mypos.lk",
    welcomeMessage: "Welcome to myPOS Cloud",
    loginUIMessage: "myPOS Cloud",
  }
}



